import React, { useEffect, useRef } from "react";
import { Col, Container, Row } from "reactstrap";
import useWindowDimensions from "../common/WindowResize";
import withViewport from "../hoc/withViewport";
import styles from "./Header.module.scss";
import Navigation from "./Navigation/Navigation";

const Header = (props) => {
  const { style, setMenuHeight } = props;

  const ref = useRef(null);
  const { height, width } = useWindowDimensions();

  useEffect(() => {
    setMenuHeight(ref.current.clientHeight);
  }, [width, height, setMenuHeight]);

  return (
    <header ref={ref} className={styles.header} style={style}>
      <Container className="" fluid={true}>
        <Row className="">
          <Col className={styles.col}>
            <Navigation
              isMobile={props.viewport !== "desktop"}
              setAuthenticated={props.setAuthenticated}
              hideSideNav={props.hideSideNav}
            />
          </Col>
        </Row>
      </Container>
    </header>
  );
};

export default withViewport(Header);
